var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow09 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 26,
    viewBox: "0 0 72 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1692_15706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 22.483C0.150439 21.5218 0.0752193 20.5606 0.376096 19.656C0.827412 18.3555 1.42917 17.0551 2.3318 15.8678C7.82281 8.51754 15.7961 3.08969 26.5524 0.82808C37.5344 -1.43353 47.9147 0.375753 56.5649 6.25594C60.9276 9.19603 64.2373 12.7581 66.7947 16.7159C67.246 17.4509 67.6974 18.1294 68.5248 19.3167C69.5026 17.6771 70.2548 16.4332 71.007 15.1328C71.2327 15.1893 71.4583 15.1893 71.7592 15.2458C71.8344 15.6416 72.0601 16.0374 71.9849 16.4332C71.7592 18.4121 71.4583 20.391 71.1574 22.3699C70.9318 23.6703 70.7813 25.0273 68.9009 25.5927C66.9452 26.2146 65.2903 25.3665 64.0116 24.4054C62.2816 23.0484 60.702 21.5218 59.1976 19.9952C58.8967 19.656 59.1976 19.034 59.1976 18.5252C59.8746 18.5252 60.702 18.3555 61.1533 18.5817C62.5072 19.3167 63.6355 20.2214 64.9142 21.126C64.9895 20.9564 65.1399 20.8433 65.0647 20.7868C59.1976 8.34792 47.1625 0.941161 30.0125 2.24159C29.1851 2.29813 28.3577 2.4112 27.5303 2.63737C16.0217 5.40784 7.52193 10.7792 2.3318 19.034C1.65482 20.1083 1.35395 21.3522 0.902631 22.5395C0.601753 22.5395 0.300877 22.483 0 22.483Z",
    fill: "#3EB786"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1692_15706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 26,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow09);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Arrow_09.b7289954f45326ecac9b691a5df55769.svg";